import Vue from 'vue';
let day1 = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
let day2 = ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'];
Vue.filter('day', function (val, type) {
    if(!val)return '';
    let day = val.getDay();
    if (day < 7 && day >= 0) {
        let d = '';
        switch (type) {
            case 'max':
                d = day2[day];
                break;
            case 'min':
                d = day1[day];
                break;
            default:
                d = day1[day];
        }
        return d;
    } else {
        return '';
    }
});